import { createHttpLink, ApolloClient, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { gql } from 'graphql-tag';

var createStateManager = function createStateManager(notificationCallback) {
  var userVehicleState = {
    vehicles: undefined,
    selectedVehicle: undefined,
    requestOrderBy: undefined
  };
  var findVehicleByVIN = function findVehicleByVIN(vin) {
    var _userVehicleState$veh;
    if (vin && userVehicleState.vehicles && ((_userVehicleState$veh = userVehicleState.vehicles) == null ? void 0 : _userVehicleState$veh.length) > 0) {
      var _userVehicleState$veh2;
      return (_userVehicleState$veh2 = userVehicleState.vehicles) == null ? void 0 : _userVehicleState$veh2.find(function (vehicle) {
        return vehicle.vin === vin;
      });
    }
    return undefined;
  };
  var getSelectedVehicle = function getSelectedVehicle() {
    return userVehicleState.selectedVehicle;
  };
  var notify = function notify() {
    if (!notificationCallback) return;
    notificationCallback(userVehicleState);
  };
  var setSelectedVehicle = function setSelectedVehicle(selected, sendNotify) {
    if (sendNotify === void 0) {
      sendNotify = true;
    }
    var newSelectedVehicle;
    if (!selected) {
      newSelectedVehicle = selected;
    } else {
      if (selected.vin && findVehicleByVIN(selected.vin)) {
        newSelectedVehicle = selected;
      } else {
        return;
      }
    }
    userVehicleState.selectedVehicle = newSelectedVehicle;
    if (sendNotify) notify();
  };
  var getVehicles = function getVehicles() {
    if (userVehicleState.vehicles) {
      return [].concat(userVehicleState.vehicles);
    }
    return undefined;
  };
  var setVehicles = function setVehicles(vehicles, orderBy) {
    var _userVehicleState$sel;
    var newVehicles = [].concat(vehicles);
    userVehicleState.vehicles = newVehicles;
    userVehicleState.requestOrderBy = orderBy;
    if (userVehicleState.selectedVehicle && (_userVehicleState$sel = userVehicleState.selectedVehicle) != null && _userVehicleState$sel.vin) {
      var updatedSelectedVehicle = findVehicleByVIN(userVehicleState.selectedVehicle.vin);
      setSelectedVehicle(updatedSelectedVehicle, false);
    } else {
      setSelectedVehicle(undefined, false);
    }
    notify();
  };
  return {
    getVehicles: getVehicles,
    setVehicles: setVehicles,
    getSelectedVehicle: getSelectedVehicle,
    setSelectedVehicle: setSelectedVehicle,
    findVehicleByVIN: findVehicleByVIN
  };
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _taggedTemplateLiteralLoose(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}

var VehicleSortOrder;
(function (VehicleSortOrder) {
  VehicleSortOrder["UNORDERED"] = "UNORDERED";
  VehicleSortOrder["FAVORITE_AND_REGISTRATION"] = "FAVORITE_AND_REGISTRATION";
  VehicleSortOrder["REGISTRATION"] = "REGISTRATION";
})(VehicleSortOrder || (VehicleSortOrder = {}));

var createVGQLClient = function createVGQLClient(authService, config) {
  var httpLink = createHttpLink({
    uri: '',
    fetch: function fetch(input, init) {
      if (typeof input !== 'string') {
        return Promise.reject(new Error('input parameter for fetching must be a string!'));
      }
      return authService.fetch(input, _extends({
        resourceHostId: 'retailservices'
      }, init));
    }
  });
  var authLink = setContext(function (_, _ref) {
    var headers = _ref.headers;
    try {
      return Promise.resolve({
        uri: 'vgql/v1/graphql',
        headers: _extends({}, headers, config.headers)
      });
    } catch (e) {
      return Promise.reject(e);
    }
  });
  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        // Apollo is having issues with distinguishing requests and returns cached results even when
        // the request is a different one
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      }
    }
  });
};

var _templateObject$7;
var ADD_USER_VEHICLE = gql(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  mutation ($vin: String) {\n    addUserVehicle(vin: $vin)\n  }\n"])));
var addUserVehicle = function addUserVehicle(client, vin, countryCode) {
  try {
    return Promise.resolve(client.mutate({
      mutation: ADD_USER_VEHICLE,
      variables: {
        vin: vin
      },
      context: {
        headers: {
          'x-user-country': countryCode.toUpperCase()
        }
      }
    })).then(function (result) {
      return result.data ? result.data : null;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject$6;
var DELETE_VEHICLE_NICKNAME = gql(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n  mutation DeleteNickname($vin: String!) {\n    deleteNickname(vin: $vin)\n  }\n"])));
var deleteVehicleNickname = function deleteVehicleNickname(client, vin) {
  try {
    return Promise.resolve(client.mutate({
      mutation: DELETE_VEHICLE_NICKNAME,
      variables: {
        vin: vin
      }
    })).then(function (result) {
      return result == null ? void 0 : result.data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject$5, _templateObject2$1;
var SET_FAVORITE_USER_VEHICLE_MUTATION = gql(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n  mutation SET_FAVORITE_USER_VEHICLE_MUTATION($vin: String!) {\n    setFavorite(vin: $vin)\n  }\n"])));
var REMOVE_FAVORITE_USER_VEHICLE_MUTATION = gql(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  mutation REMOVE_FAVORITE_USER_VEHICLE_MUTATION {\n    removeFavorite\n  }\n"])));
var setFavoriteUserVehicle = function setFavoriteUserVehicle(client, vin) {
  try {
    return Promise.resolve(client.mutate({
      mutation: SET_FAVORITE_USER_VEHICLE_MUTATION,
      variables: {
        vin: vin
      }
    })).then(function (result) {
      if (!result.data) {
        throw new Error('Error while trying to set a favorite vehicle');
      }
      return result.data.setFavorite;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var removeFavoriteUserVehicle = function removeFavoriteUserVehicle(client) {
  try {
    return Promise.resolve(client.mutate({
      mutation: REMOVE_FAVORITE_USER_VEHICLE_MUTATION
    })).then(function (result) {
      if (!result.data) {
        throw new Error('Error while trying to remove a favorite vehicle');
      }
      return true;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject$4;
var REMOVE_USER_VEHICLE = gql(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  mutation UnregisterUserVehicle($vehicleCoreId: String!) {\n    removeUserVehicle(vehicleCoreId: $vehicleCoreId)\n  }\n"])));
var removeUserVehicle = function removeUserVehicle(client, vin) {
  try {
    return Promise.resolve(client.mutate({
      mutation: REMOVE_USER_VEHICLE,
      variables: {
        vehicleCoreId: vin
      }
    })).then(function (result) {
      return result.data ? result.data : null;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject$3;
var SET_VEHICLE_NICKNAME = gql(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  mutation SetNickname($vin: String!, $nickname: String!) {\n    setNickname(vin: $vin, nickname: $nickname)\n  }\n"])));
var setVehicleNickname = function setVehicleNickname(client, vin, nickname) {
  try {
    return Promise.resolve(client.mutate({
      mutation: SET_VEHICLE_NICKNAME,
      variables: {
        vin: vin,
        nickname: nickname
      }
    })).then(function (result) {
      return result.data ? result.data : null;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject$2, _templateObject2;
var GET_USER_VEHICLES_QUERY = gql(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  query GET_USER_VEHICLES {\n    userVehicles {\n      csid\n      userId\n      vin\n      owner\n      nickname\n      favorite\n      devicePlatform\n      mbbConnect\n      userRole {\n        role\n      }\n      vehicle {\n        brand {\n          name\n        }\n        classification {\n          driveTrain\n        }\n        core {\n          vin\n          modelYear\n          modelCoding\n        }\n        media {\n          exteriorColor\n          interiorColor\n          shortName\n          longName\n        }\n        renderPictures(mediaTypes: [\"MYAPN8NB\", \"MS_MYP3\", \"MS_MYP4\", \"MS_MYP5\"]) {\n          mediaType\n          url\n        }\n        pdw {\n          pdwVehicle\n        }\n      }\n    }\n  }\n"])));
var GET_USER_VEHICLES_ORDERED_QUERY = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  query GET_USER_VEHICLES_ORDERED_BY($orderBy: VehicleSortOrder!) {\n    userVehicles(orderBy: $orderBy) {\n      csid\n      userId\n      vin\n      owner\n      nickname\n      favorite\n      devicePlatform\n      mbbConnect\n      userRole {\n        role\n      }\n      vehicle {\n        brand {\n          name\n        }\n        classification {\n          driveTrain\n        }\n        core {\n          vin\n          modelYear\n          modelCoding\n        }\n        media {\n          exteriorColor\n          interiorColor\n          shortName\n          longName\n        }\n        renderPictures(mediaTypes: [\"MYAPN8NB\", \"MS_MYP3\", \"MS_MYP4\", \"MS_MYP5\"]) {\n          mediaType\n          url\n        }\n        pdw {\n          pdwVehicle\n        }\n      }\n    }\n  }\n"])));
var getAllVehicles = function getAllVehicles(client, orderBy) {
  try {
    if (orderBy === undefined) orderBy = VehicleSortOrder.FAVORITE_AND_REGISTRATION;
    var isOrdered = orderBy !== VehicleSortOrder.UNORDERED;
    return Promise.resolve(client.query({
      query: isOrdered ? GET_USER_VEHICLES_ORDERED_QUERY : GET_USER_VEHICLES_QUERY,
      variables: isOrdered ? {
        orderBy: orderBy
      } : undefined
    })).then(function (result) {
      var _result$data$userVehi;
      return (_result$data$userVehi = result.data.userVehicles) != null ? _result$data$userVehi : [];
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject$1;
var GET_USER_VEHICLE_QUERY = gql(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  query GET_USER_VEHICLE($vin: String!) {\n    userVehicle(vehicleCoreId: $vin) {\n      csid\n      userId\n      vin\n      owner\n      nickname\n      favorite\n      devicePlatform\n      mbbConnect\n      userRole {\n        role\n      }\n      vehicle {\n        brand {\n          name\n        }\n        classification {\n          driveTrain\n        }\n        core {\n          vin\n          modelYear\n          modelCoding\n        }\n        media {\n          exteriorColor\n          interiorColor\n          shortName\n          longName\n        }\n        renderPictures(mediaTypes: [\"MYAPN8NB\", \"MS_MYP3\", \"MS_MYP4\", \"MS_MYP5\"]) {\n          mediaType\n          url\n        }\n        pdw {\n          pdwVehicle\n        }\n      }\n    }\n  }\n"])));
var getVehicle = function getVehicle(client, vin) {
  try {
    return Promise.resolve(client.query({
      query: GET_USER_VEHICLE_QUERY,
      variables: {
        vin: vin
      }
    })).then(function (result) {
      if (!result.data) {
        throw new Error('Error while fetching vehicle data');
      }
      return result.data.userVehicle;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject;
var vehicleEquipmentDetailsFragment = "\nfragment VehicleEquipmentDetailsFragment on Vehicle {\n  equipments {\n    code\n    name\n    categoryId\n    categoryName\n    subCategoryId\n    subCategoryName\n    teaserImage\n    standard\n  }\n  techSpecs {\n    key\n    name\n    value\n    unit\n    groupId\n    groupName\n  }\n  consumption {\n    wltps {\n      attributeGroup\n      attributes {\n        attributeId\n        scaleUnit\n        value\n      }\n    }\n    technicalSpecifications {\n      key\n      name\n      value\n      unit\n      groupId\n      groupName\n    }\n  }\n}\n";
var GET_VEHICLE_EQUIPMENT_DETAILS_QUERY = gql(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n\n  query ($vin: String!) {\n    userVehicle(vehicleCoreId: $vin) {\n      vehicle {\n        ...VehicleEquipmentDetailsFragment\n      }\n    }\n  }\n"])), vehicleEquipmentDetailsFragment);
var getVehicleEquipmentDetails = function getVehicleEquipmentDetails(client, vin) {
  try {
    return Promise.resolve(client.query({
      query: GET_VEHICLE_EQUIPMENT_DETAILS_QUERY,
      variables: {
        vin: vin
      }
    })).then(function (result) {
      if (!result.data) {
        throw new Error('Error while fetching vehicle data');
      }
      return result.data.userVehicle.vehicle;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

/**
 * Breaking change compatability
 *
 * This function swallows the error, feature apps are not able to know if error happened while
 * querying vehicles. This is a major issue, the error handling should be happening on the
 * feature side.
 *
 * @deprecated
 */

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
var getVehiclesDeprecated = function getVehiclesDeprecated(client, orderBy) {
  try {
    if (orderBy === undefined) orderBy = VehicleSortOrder.FAVORITE_AND_REGISTRATION;
    return Promise.resolve(_catch(function () {
      return Promise.resolve(getAllVehicles(client, orderBy));
    }, function () {
      return undefined;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var createUserVehicleFeatureService = function createUserVehicleFeatureService(authService, state, subscribe, config) {
  var vgqlClient = createVGQLClient(authService, config);
  var getAllVehicles$1 = function getAllVehicles$1(orderBy) {
    try {
      if (orderBy === undefined) orderBy = VehicleSortOrder.FAVORITE_AND_REGISTRATION;
      var stateVehicles = state.getVehicles();
      if (stateVehicles) {
        return Promise.resolve(stateVehicles);
      }
      return Promise.resolve(getAllVehicles(vgqlClient, orderBy)).then(function (vehicles) {
        state.setVehicles(vehicles, orderBy);
        return vehicles;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * @deprecated Use getAllVehicles() instead
   */
  var getVehicles = function getVehicles(orderBy) {
    try {
      var _exit;
      if (orderBy === undefined) orderBy = VehicleSortOrder.FAVORITE_AND_REGISTRATION;
      var stateVehicles = state.getVehicles();
      var _temp = function () {
        if (!stateVehicles) {
          return Promise.resolve(getVehiclesDeprecated(vgqlClient, orderBy)).then(function (vehicles) {
            state.setVehicles(vehicles != null ? vehicles : [], orderBy);
            _exit = 1;
            return vehicles;
          });
        }
      }();
      return Promise.resolve(_temp && _temp.then ? _temp.then(function (_result) {
        return _exit ? _result : stateVehicles;
      }) : _exit ? _temp : stateVehicles);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var getAllVehiclesForce = function getAllVehiclesForce(orderBy) {
    try {
      if (orderBy === undefined) orderBy = VehicleSortOrder.FAVORITE_AND_REGISTRATION;
      return Promise.resolve(getAllVehicles(vgqlClient, orderBy)).then(function (vehicles) {
        state.setVehicles(vehicles, orderBy);
        return vehicles;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * @deprecated please use getAllVehiclesForce
   */
  var getVehiclesForce = function getVehiclesForce(orderBy) {
    try {
      if (orderBy === undefined) orderBy = VehicleSortOrder.FAVORITE_AND_REGISTRATION;
      return Promise.resolve(getVehiclesDeprecated(vgqlClient, orderBy)).then(function (vehicles) {
        state.setVehicles(vehicles != null ? vehicles : [], orderBy);
        return vehicles != null ? vehicles : [];
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var getVehicle$1 = function getVehicle$1(vin) {
    try {
      var stateVehicles = state.getVehicles();
      if (stateVehicles && (stateVehicles == null ? void 0 : stateVehicles.length) > 0) {
        return Promise.resolve(state.findVehicleByVIN(vin));
      } else {
        return Promise.resolve(getVehicle(vgqlClient, vin));
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var getVehicleEquipmentDetails$1 = function getVehicleEquipmentDetails$1(vin) {
    try {
      return Promise.resolve(getVehicleEquipmentDetails(vgqlClient, vin));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var addUserVehicleMutation = function addUserVehicleMutation(vin, countryCode) {
    try {
      var stateVehicles = state.getVehicles();
      return Promise.resolve(addUserVehicle(vgqlClient, vin, countryCode)).then(function (addVehicleData) {
        if (!addVehicleData) {
          return null;
        }
        if (stateVehicles) {
          var updatedVehicles = stateVehicles.filter(function (vehicle) {
            return vehicle.vin !== vin;
          });
          state.setVehicles(updatedVehicles, VehicleSortOrder.FAVORITE_AND_REGISTRATION);
        }
        return addVehicleData;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var setVehicleNicknameMutation = function setVehicleNicknameMutation(vin, nickname) {
    try {
      var stateVehicles = state.getVehicles();
      return Promise.resolve(setVehicleNickname(vgqlClient, vin, nickname)).then(function (nicknameData) {
        if (!nicknameData) {
          return null;
        }
        if (stateVehicles) {
          var updatedVehicles = stateVehicles.map(function (vehicle) {
            return vehicle.vin === vin ? _extends({}, vehicle, {
              nickname: nickname
            }) : vehicle;
          });
          state.setVehicles(updatedVehicles, VehicleSortOrder.FAVORITE_AND_REGISTRATION);
        }
        return {
          nickname: nicknameData.nickname
        };
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var deleteVehicleNicknameMutation = function deleteVehicleNicknameMutation(vin) {
    try {
      var stateVehicles = state.getVehicles();
      return Promise.resolve(deleteVehicleNickname(vgqlClient, vin)).then(function (nicknameDeletionData) {
        if (!nicknameDeletionData) {
          return false;
        }
        if (stateVehicles) {
          var updatedVehicles = stateVehicles.map(function (vehicle) {
            return vehicle.vin === vin ? _extends({}, vehicle, {
              nickname: undefined
            }) : vehicle;
          });
          state.setVehicles(updatedVehicles, VehicleSortOrder.FAVORITE_AND_REGISTRATION);
        }
        return true;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var removeUserVehicleMutation = function removeUserVehicleMutation(vin) {
    try {
      var stateVehicles = state.getVehicles();
      return Promise.resolve(removeUserVehicle(vgqlClient, vin)).then(function (vehicleRemovalData) {
        if (!vehicleRemovalData) {
          return null;
        }
        if (stateVehicles) {
          var updatedVehicles = stateVehicles.filter(function (vehicle) {
            return vehicle.vin !== vin;
          });
          state.setVehicles(updatedVehicles, VehicleSortOrder.FAVORITE_AND_REGISTRATION);
        }
        return vehicleRemovalData;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var setFavoriteUserVehicleHandler = function setFavoriteUserVehicleHandler(vin) {
    try {
      return Promise.resolve(setFavoriteUserVehicle(vgqlClient, vin)).then(function (result) {
        if (result) {
          var _state$getVehicles;
          var updatedVehicles = (_state$getVehicles = state.getVehicles()) == null ? void 0 : _state$getVehicles.reduce(function (vehicles, current) {
            vehicles.push(_extends({}, current, {
              favorite: current.vin === result
            }));
            return vehicles;
          }, []);
          if (updatedVehicles) {
            state.setVehicles(updatedVehicles, VehicleSortOrder.FAVORITE_AND_REGISTRATION);
          }
        }
        return result;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var removeFavoriteUserVehicleHandler = function removeFavoriteUserVehicleHandler() {
    try {
      return Promise.resolve(removeFavoriteUserVehicle(vgqlClient)).then(function (result) {
        if (result) {
          var _state$getVehicles2;
          var updatedVehicles = (_state$getVehicles2 = state.getVehicles()) == null ? void 0 : _state$getVehicles2.reduce(function (vehicles, current) {
            vehicles.push(_extends({}, current, {
              favorite: false
            }));
            return vehicles;
          }, []);
          if (updatedVehicles) {
            state.setVehicles(updatedVehicles, VehicleSortOrder.FAVORITE_AND_REGISTRATION);
          }
          return true;
        }
        return false;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return {
    subscribe: subscribe,
    getAllVehicles: getAllVehicles$1,
    getVehicles: getVehicles,
    getVehicle: getVehicle$1,
    getAllVehiclesForce: getAllVehiclesForce,
    getVehiclesForce: getVehiclesForce,
    getVehicleEquipmentDetails: getVehicleEquipmentDetails$1,
    getSelectedVehicle: state.getSelectedVehicle,
    setSelectedVehicle: state.setSelectedVehicle,
    setVehicleNickname: setVehicleNicknameMutation,
    addUserVehicle: addUserVehicleMutation,
    deleteVehicleNickname: deleteVehicleNicknameMutation,
    removeUserVehicle: removeUserVehicleMutation,
    setFavoriteUserVehicle: setFavoriteUserVehicleHandler,
    removeFavoriteUserVehicle: removeFavoriteUserVehicleHandler
  };
};

var requiredFeatureServices = {
  's2:logger': '^1.0.0',
  'vw:authService': '^4.0.0',
  'pubsub-service': '^1.0.0',
  'locale-service': '^1.0.0'
};
function defineUserVehicleFeatureService(options) {
  var id = 'user-vehicle-feature-service';
  return {
    id: id,
    dependencies: {
      featureServices: requiredFeatureServices
    },
    create: function create(_ref) {
      var featureServices = _ref.featureServices;
      var loggerService = featureServices['s2:logger'];
      var logger = loggerService || console;
      var provider = featureServices['vw:authService'];
      var authService = provider.register('myaudi');
      var pubsubService = featureServices['pubsub-service'];
      var localeService = featureServices['locale-service'];
      var stateManager = createStateManager(function (data) {
        return pubsubService.publish(id, data);
      });
      var config = (options == null ? void 0 : options.vgqlConfig) || {
        headers: {
          'Accept-Language': localeService.language + "-" + localeService.countryCode
        }
      };
      var v1 = createUserVehicleFeatureService(authService, stateManager, function (callback) {
        return pubsubService.subscribe(id, callback);
      }, config);
      logger.debug('FeatureService created');
      return {
        '1.0.0': function _() {
          return {
            featureService: v1
          };
        }
      };
    }
  };
}

export { VehicleSortOrder, defineUserVehicleFeatureService };
//# sourceMappingURL=index.modern.js.map
